export default {
  Campos: {
    SenhaAtual: {
      Tipo: "text",
      TipoInput: "password",
      Label: "Senha atual",
      Obrigatorio: true
    },
    NovaSenha: {
      Tipo: "text",
      TipoInput: "password",
      Label: "Nova senha",
      Obrigatorio: true
    },
    ConfirmarSenha: {
      Tipo: "text",
      TipoInput: "password",
      Label: "Confirmar nova senha",
      Obrigatorio: true
    }
  }
};
